/*
    Defines the API route we are using.
*/
var apiUrl = "";

switch (process.env.NODE_ENV) {
  case "development":
    apiUrl = "/api/v1";
    break;
  case "production":
    apiUrl = "/api/v1";
    break;
}

export const API_URL = apiUrl;
